import InqueryResult from './inquery-result.vue'
export default InqueryResult
